import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectProgramHubsListItems } from "../../../../../redux/program-hubs/selector";
import { programHubs } from "../../../../../redux/program-hubs/action";
import { programSubscriptions } from "../../../../../redux/program-subscriptions/action";
import ProgramsDetailsModal from "../components/programs-modal.component";
import Popup from "../../../../../common/components/popup";


export const AvailablePrograms = () => {
  const dispatch = useAppDispatch();
  const [dbaasProgram, setDBaasProgram] = useState<any[]>([]);;
  const programItems = useSelector(selectProgramHubsListItems);
  const image = require('../../../../../assets/img/image 1.png');
  const [selectPrograms, setSelectPrograms] = useState<any>({});
  const [showDetailsModal, setShowDetailsModal] = useState(false);


  useEffect(() => {
    dispatch(programHubs.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/one-programs/plans-list`,
      entity: 'programHubs',
      jsonData: {
        "Context": {
          "Subscription": "ONE",
          "Domain": "ONE",
          "SubDomains": [],
          "Network": "ONEUser",
          "Application": "ONEUser",
          "Channel": "CSP"
        },
        "Records": [
          {
            "Id": 0
          }
        ],

      }
    }));
  }, [dispatch]);

  const fetchProgramsList = () => {
    dispatch(programHubs.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/one-programs/plans-list`,
      entity: 'programHubs',
      jsonData: {
        "Context": {
          "Subscription": "ONE",
          "Domain": "ONE",
          "SubDomains": [],
          "Network": "ONEUser",
          "Application": "ONEUser",
          "Channel": "CSP"
        },
        "Records": [
          {
            "Id": 0
          }
        ],
      }
    }));
  };

  useEffect(() => {
    setDBaasProgram(programItems?.result?.items || []);
  }, [programItems]);

  const handleSubscribe = async (data: any) => {

    await dispatch(programSubscriptions.resetAction({ actionType: 'create' }));
    await dispatch(programSubscriptions.create({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-program-subscriptions`,
      entity: 'programSubscriptions',
      jsonData: {
        Context: {
          Subscription: "ONE",
          Domain: "ONE",
          SubDomains: [],
          Network: "ONEUser",
          Application: "ONEUser",
          Channel: "CSP"
        },
        Records: [
          {
            OwnerType: "oneprogram",
            ONEProgramPolicyId: data?.EntityInfo?.ONEProgramPolicyId,
            IsExistingUser: true,
            OwnerId: data.Id
          }
        ]
      }
    })).then(() => {

      fetchProgramsList();
    });
  };


  const handleDetails = (programs: any) => {
    setSelectPrograms(programs);
    setShowDetailsModal(true);
  };

  const closeModal = () => {
    setShowDetailsModal(false);
    setSelectPrograms({});
  };

  const NewItemPopup = () => (
    <Popup onClose={closeModal}>
      <ProgramsDetailsModal Close={closeModal} selectPrograms={selectPrograms} />
    </Popup>
  );

  return (
    <>
      {showDetailsModal && <NewItemPopup />}


      <div className="min-h-screen bg-red px-4 py-6">
        <div className="max-w-7xl mx-auto">

          <h2 className="text-center text-xl md:text-2xl font-bold text-gray-800 mb-6">
            Available Programs
          </h2>

          {dbaasProgram.length === 0 ? (
            <div className="text-center text-gray-600 text-md">
              No available Programs to show.
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {dbaasProgram.map((programs, index) => (
                <div
                  key={programs?.Id || index}
                  className="flex flex-col border border-gray-300 rounded-lg bg-gray-50 hover:border-gray-500 hover:shadow-md transition-transform hover:scale-105 p-3"
                >
                  <div className="relative w-full">
                    <div className="w-full h-0 pb-[60%] bg-zinc-200 rounded-md overflow-hidden">
                      <img
                        className="absolute inset-0 w-full h-full object-contain"
                        src={programs?.EntityInfo?.MediaMappings?.MediaFiles || image}
                        alt={programs?.EntityInfo?.Name || "Subscription Image"}
                      />
                    </div>
                  </div>

                  <div className="mt-2 text-sm text-center">
                    <div className="font-semibold text-black truncate">{programs?.EntityInfo?.Name}</div>

                  </div>

                  <div className="mt-3 flex gap-3">
                    <button
                      className="bg-blue-600 w-40 hover:bg-blue-700 text-white text-sm px-4 py-2 rounded-md flex items-center transition duration-200 shadow hover:shadow-lg"
                      onClick={() => handleDetails(programs)}
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" className="mr-2">
                        <path d="M12 5v14M5 12h14" />
                      </svg>
                      More Details
                    </button>

                    <button
                      className="bg-green-600 w-40 hover:bg-green-700 text-white text-sm px-4 py-2 rounded-md flex items-center transition duration-200 shadow hover:shadow-lg"

                      onClick={() => handleSubscribe(programs)}
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" className="mr-2">
                        <path d="M12 5v14M5 12h14" />
                      </svg>
                      subscribe
                    </button>
                  </div>

                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );

};










